import styled from "styled-components";
export const SpinLoaderContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotateY(360deg);
    }
  }
  .image-outer-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }
  .image-inner-wrapper {
    animation: rotation 1.5s infinite;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }
`;
